import { z } from 'zod';

/** Mesmos limites do back (`alocacao_tag.nome varchar(60)`; cor em hex, como o `TColor` do legado). */
export const TAG_NAME_MAX_LENGTH = 60;
export const TAG_COLOR_PATTERN = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export const allocationTagFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { message: 'required' })
    .max(TAG_NAME_MAX_LENGTH, { message: 'tooLong' }),
  color: z.string().trim().regex(TAG_COLOR_PATTERN, { message: 'invalidColor' }),
  active: z.boolean(),
});

export type AllocationTagFormValues = z.infer<typeof allocationTagFormSchema>;
